import React from 'react';
import styled from 'styled-components';
const Loading = styled.div `
  width: 100%;
  height: 100%;

  background: linear-gradient(90deg, #ddd 0px, #eee 40px, #ddd 80px);
  animation: shine 4s infinite linear;

  @keyframes shine {
    0% {
      background-position: 0px;
    }
    100% {
      background-position: 1000px;
    }
  }
`;
export const Skeleton = ({ htmlAttrs = {} }) => (React.createElement(Loading, { ...htmlAttrs }));
//# sourceMappingURL=index.js.map